// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.theme-blue .v-expansion-panel-title[data-v-5b7e4ffc] {\r\n        background-color: #4B6FB2 !important;\r\n        color: white !important;\n}\n.theme-blue .v-expansion-panel-text[data-v-5b7e4ffc] {\r\n        background-color: #c5d0ea !important;\n}\r\n\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
